import React from "react";
import { get } from "lodash";
import { useParams } from "react-router-dom";
import { getPublicBulletin } from "../../../queries/communications";
import useNetworkHeaders from "../../../hooks/useNetworkHeaders";
import { useQuery } from "react-query";
import useNotifySocialMediaPreview from "../hooks/useNotifySocialMediaImagePreview";
import { useClient } from "../../../hooks/use-client";

const SocialMediaPreview = () => {
  const { id, site } = useSocialMediaPreviewParams();
  const { data } = usePublicCommunicationDetails(id);

  const client = useClient(site);

  const [finishedDrawing, setFinishedDrawing] = React.useState(false);

  const citySeal = get(client.query, "data.payload.data.attributes.seal") ?? "";
  const headline = get(data, "data.attributes.headline") ?? "";
  const tagline = get(data, "data.attributes.preview") ?? "";
  const content = get(data, "data.attributes.content") ?? "";

  const onFinishedDrawing = () => {
    setFinishedDrawing(true);
  };

  const { canvasRef } = useNotifySocialMediaPreview({
    citySeal,
    headline,
    tagline,
    content,
    onComplete: onFinishedDrawing,
  });

  /**
   * I know this id seems weird but its important for the backend. On the backend, we use puppeteer to take a screenshot of this
   * page. The screenshot is taken when the element with this id is present in the DOM -- Peter
   */
  const loadedId = "social-media-preview-loaded";
  return (
    <div>
      <canvas height={1200} width={1200} ref={canvasRef} />
      {finishedDrawing && <div id={loadedId} className='tw-hidden' />}
    </div>
  );
};

const useSocialMediaPreviewParams = () => {
  return useParams<{ site: string; id: string }>();
};

const usePublicCommunicationDetails = (id: string | number) => {
  const headers = useNetworkHeaders();
  const query = useQuery(["bulletins.public", id.toString()], getPublicBulletin(headers));
  return {
    data: query.data,
    isLoading: query.isLoading,
  };
};

export default SocialMediaPreview;
